import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-6 lg:px-8 bg-palegreen" data-id="element-97">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-98">
        <ShieldCheck size={64} className="mx-auto mb-6 text-green-700" data-id="element-99" />
        <h2 className="text-5xl md:text-7xl font-extrabold mb-2 text-green-900" data-id="element-100">
          7 DÍAS
        </h2>
        <h3 className="text-2xl md:text-4xl font-extrabold mb-8 text-green-800 tracking-widest" data-id="element-101">
          GARANTÍA TOTAL
        </h3>

        <p className="text-xl md:text-2xl font-medium text-green-900/80 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-102">
          "Abrís los tomos, probás los bonos, aplicás las técnicas. Si en 7 días
          no sentís que vale lo que pagaste: sin preguntas, sin formularios, sin
          drama. Te devolvemos el 100%."
        </p>

        <p className="text-sm font-bold text-green-900/50 uppercase tracking-widest" data-id="element-103">
          (Tasa de devoluciones &lt; 1%)
        </p>
      </div>
    </section>;
}